import { Helmet } from 'react-helmet-async';
import './landing-variants.css';

const features = [
  { num: '01', title: 'Agenda intelligent', desc: 'Optimisation automatique des créneaux, zéro trou dans votre planning.' },
  { num: '02', title: 'Dossiers patients', desc: 'Historique clinique complet, accessible en un geste depuis le fauteuil.' },
  { num: '03', title: 'Facturation fluide', desc: 'Devis, factures et relances — tout se gère sans quitter votre flux.' },
  { num: '04', title: 'Multi-cabinet', desc: 'Pilotez plusieurs sites depuis un tableau de bord unifié, en temps réel.' },
];

const stats = [
  { value: '240+', label: 'cabinets', sub: 'nous font confiance' },
  { value: '61k', label: 'rendez-vous', sub: 'gérés chaque mois' },
  { value: '34%', label: 'de temps', sub: 'économisé par praticien' },
];

export default function LandingV1() {
  return (
    <div className="doctif-page" style={{ fontFamily: "'Outfit', sans-serif", background: '#0e0e0e', color: '#e8e4de' }}>
      <Helmet><title>doctif — Gestion dentaire, réinventée</title></Helmet>

      {/* Grain texture overlay */}
      <div aria-hidden style={{
        position: 'fixed', inset: 0, zIndex: 1, pointerEvents: 'none', opacity: 0.035,
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat', backgroundSize: '200px',
        animation: 'doctifGrain 8s steps(10) infinite',
      }} />

      {/* Gold accent line at very top */}
      <div aria-hidden style={{ height: 2, background: 'linear-gradient(90deg, transparent, #d4af37, transparent)' }} />

      {/* ── Header ── */}
      <header className="doctif-shell" style={{ padding: '28px 0 20px', position: 'relative', zIndex: 10 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 38, color: '#d4af37', letterSpacing: '-0.02em' }}>doctif</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <nav className="doctif-chip-row">
              <a className="doctif-chip" href="/1/" style={{ background: '#d4af37', color: '#0e0e0e' }}>01</a>
              <a className="doctif-chip" href="/2/" style={{ background: '#1a1a1a', color: '#777', border: '1px solid #333' }}>02</a>
              <a className="doctif-chip" href="/3/" style={{ background: '#1a1a1a', color: '#777', border: '1px solid #333' }}>03</a>
            </nav>
            <a href="/accounts/login/" style={{
              color: '#d4af37', textDecoration: 'none', fontWeight: 600, fontSize: 14,
              padding: '8px 18px', border: '1px solid #d4af3744', borderRadius: 8,
              transition: 'all 0.3s',
            }}>Connexion</a>
          </div>
        </div>
      </header>

      {/* ── Hero ── */}
      <section className="doctif-shell" style={{ position: 'relative', zIndex: 5, paddingTop: 40, paddingBottom: 60 }}>
        {/* Decorative diagonal gold line */}
        <div aria-hidden style={{
          position: 'absolute', top: -20, right: 120, width: 1, height: 180,
          background: 'linear-gradient(180deg, transparent, #d4af3733, transparent)',
          transform: 'rotate(25deg)',
        }} />

        <p className="doctif-kicker doctif-fade-up" style={{ color: '#d4af37', marginBottom: 20 }}>
          La suite clinique qui change la donne
        </p>

        <h1 className="doctif-fade-up doctif-delay-1" style={{
          fontFamily: "'DM Serif Display', serif", fontWeight: 400,
          fontSize: 'clamp(2.8rem, 7.5vw, 6.5rem)', lineHeight: 0.95,
          maxWidth: 900, marginBottom: 28, letterSpacing: '-0.025em',
        }}>
          <span style={{ color: '#e8e4de' }}>Le cabinet</span>
          <br />
          <span style={{ color: '#d4af37', fontStyle: 'italic' }}>réinventé.</span>
        </h1>

        <div className="doctif-fade-up doctif-delay-2" style={{
          display: 'grid', gridTemplateColumns: '1fr auto', gap: 60, alignItems: 'end',
          maxWidth: 900,
        }}>
          <p style={{ fontSize: 18, lineHeight: 1.7, color: '#9a958d', maxWidth: 520 }}>
            doctif fusionne agenda, dossiers patients et facturation dans une interface unique — 
            pensée, dessinée, raffinée pour les praticiens qui refusent le médiocre.
          </p>
          <a href="/accounts/login/" className="doctif-fade-up doctif-delay-3" style={{
            display: 'inline-flex', alignItems: 'center', gap: 10,
            background: '#d4af37', color: '#0e0e0e', padding: '14px 28px',
            borderRadius: 10, fontWeight: 700, fontSize: 15, textDecoration: 'none',
            transition: 'transform 0.2s, box-shadow 0.2s',
            boxShadow: '0 8px 30px rgba(212,175,55,0.25)',
          }}>
            Commencer gratuitement
            <span style={{ fontSize: 20 }}>→</span>
          </a>
        </div>
      </section>

      {/* ── Stats strip ── */}
      <section style={{
        borderTop: '1px solid #1f1f1f', borderBottom: '1px solid #1f1f1f',
        background: '#111', position: 'relative', zIndex: 5,
      }}>
        <div className="doctif-shell" style={{
          display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)',
          padding: '36px 0',
        }}>
          {stats.map((s, i) => (
            <div key={s.label} className={`doctif-fade-up doctif-delay-${i + 2}`} style={{
              textAlign: i === 1 ? 'center' : i === 2 ? 'right' : 'left',
              borderRight: i < 2 ? '1px solid #1f1f1f' : 'none',
              paddingRight: i < 2 ? 20 : 0,
              paddingLeft: i > 0 ? 20 : 0,
            }}>
              <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 48, color: '#d4af37', lineHeight: 1 }}>{s.value}</div>
              <div style={{ fontSize: 13, color: '#777', marginTop: 6 }}>{s.label} <span style={{ color: '#555' }}>— {s.sub}</span></div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Features (asymmetric) ── */}
      <section className="doctif-shell" style={{ padding: '80px 0 60px', position: 'relative', zIndex: 5 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 50 }}>
          <h2 className="doctif-fade-up" style={{
            fontFamily: "'DM Serif Display', serif", fontSize: 'clamp(1.6rem, 4vw, 3rem)',
            fontWeight: 400, color: '#e8e4de',
          }}>
            Quatre piliers,<br /><span style={{ color: '#d4af37', fontStyle: 'italic' }}>un seul flux.</span>
          </h2>
          <p className="doctif-fade-up doctif-delay-1" style={{ color: '#555', fontSize: 13, maxWidth: 280 }}>
            Chaque module est conçu pour s'intégrer sans friction dans votre journée clinique.
          </p>
        </div>

        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)',
          gap: 16, position: 'relative',
        }}>
          {features.map((f, i) => (
            <article key={f.num} className={`doctif-fade-up doctif-delay-${Math.min(i + 1, 5)}`} style={{
              background: '#161616', border: '1px solid #222',
              borderRadius: 16, padding: '28px 26px',
              marginTop: i === 1 || i === 3 ? 30 : 0,
              transition: 'border-color 0.3s, box-shadow 0.3s',
              cursor: 'default',
            }}
              onMouseEnter={e => { (e.currentTarget as HTMLElement).style.borderColor = '#d4af3744'; (e.currentTarget as HTMLElement).style.boxShadow = '0 12px 40px rgba(212,175,55,0.08)'; }}
              onMouseLeave={e => { (e.currentTarget as HTMLElement).style.borderColor = '#222'; (e.currentTarget as HTMLElement).style.boxShadow = 'none'; }}
            >
              <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 40, color: '#d4af3733', lineHeight: 1, marginBottom: 16 }}>{f.num}</div>
              <h3 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 24, color: '#e8e4de', marginBottom: 10, fontWeight: 400 }}>{f.title}</h3>
              <p style={{ color: '#777', lineHeight: 1.65, fontSize: 15 }}>{f.desc}</p>
            </article>
          ))}
        </div>
      </section>

      {/* ── Dashboard Preview ── */}
      <section className="doctif-shell" style={{ paddingBottom: 80, position: 'relative', zIndex: 5 }}>
        <div style={{
          borderRadius: 20, border: '1px solid #1f1f1f',
          background: 'linear-gradient(165deg, #141414, #0e0e0e)',
          padding: 28, boxShadow: '0 40px 80px -30px rgba(0,0,0,0.8)',
          animation: 'doctifGlow 4s ease-in-out infinite',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 22 }}>
            <div>
              <p style={{ fontSize: 11, color: '#555', letterSpacing: '0.15em', textTransform: 'uppercase', fontWeight: 700 }}>Aperçu du jour</p>
              <h3 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 28, color: '#e8e4de', marginTop: 4 }}>Mardi 25 Mars</h3>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              {['Agenda', 'Patients', 'Factures'].map((tab, i) => (
                <span key={tab} style={{
                  padding: '6px 14px', borderRadius: 8, fontSize: 13, fontWeight: 600,
                  background: i === 0 ? '#d4af37' : '#1a1a1a',
                  color: i === 0 ? '#0e0e0e' : '#555',
                  border: i === 0 ? 'none' : '1px solid #222',
                }}>{tab}</span>
              ))}
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
            {[
              { time: '08:30', patient: 'M. Benali', type: 'Contrôle', status: '#d4af37' },
              { time: '09:15', patient: 'Mme. Idrissi', type: 'Détartrage', status: '#4ade80' },
              { time: '10:00', patient: 'M. Lahlou', type: 'Prothèse', status: '#60a5fa' },
            ].map(appt => (
              <div key={appt.time} style={{
                background: '#1a1a1a', borderRadius: 12, padding: '16px 14px',
                borderLeft: `3px solid ${appt.status}`,
              }}>
                <div style={{ color: '#d4af37', fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{appt.time}</div>
                <div style={{ color: '#e8e4de', fontWeight: 600, fontSize: 15
 }}>{appt.patient}</div>
                <div style={{ color: '#555', fontSize: 13, marginTop: 2 }}>{appt.type}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{ borderTop: '1px solid #1f1f1f', position: 'relative', zIndex: 5 }}>
        <div className="doctif-shell" style={{ padding: '70px 0', textAlign: 'center' }}>
          <h2 style={{
            fontFamily: "'DM Serif Display', serif", fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            fontWeight: 400, marginBottom: 18,
          }}>
            Prêt à <span style={{ color: '#d4af37', fontStyle: 'italic' }}>élever</span> votre pratique ?
          </h2>
          <p style={{ color: '#777', maxWidth: 500, margin: '0 auto 28px', lineHeight: 1.7 }}>
            Rejoignez les praticiens qui ont choisi l'exigence.
            Sans engagement, sans carte bancaire.
          </p>
          <a href="/accounts/login/" style={{
            display: 'inline-flex', alignItems: 'center', gap: 10,
            background: '#d4af37', color: '#0e0e0e', padding: '16px 32px',
            borderRadius: 12, fontWeight: 700, fontSize: 16, textDecoration: 'none',
            boxShadow: '0 10px 40px rgba(212,175,55,0.3)',
          }}>
            Démarrer avec doctif <span style={{ fontSize: 20 }}>→</span>
          </a>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer style={{ borderTop: '1px solid #1a1a1a', position: 'relative', zIndex: 5 }}>
        <div className="doctif-shell" style={{ padding: '24px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontFamily: "'DM Serif Display', serif", fontSize: 20, color: '#333' }}>doctif</span>
          <span style={{ color: '#333', fontSize: 12 }}>Direction éditoriale noir & or — Version 01</span>
        </div>
      </footer>

      <style>{`
        @media (max-width: 768px) {
          .doctif-shell > div[style*='grid-template-columns: repeat(2'] { grid-template-columns: 1fr !important; }
          .doctif-shell > div[style*='grid-template-columns: 1fr auto'] { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
}
